export default "__VITE_ASSET__DTy5STYn__"